// Convex client for the web app.

import { ConvexReactClient } from "convex/react";

const CONVEX_URL =
  (import.meta as ImportMeta & { env: { VITE_CONVEX_URL?: string } }).env
    .VITE_CONVEX_URL ??
  // Fallback for `npm run dev` without local env. Production builds
  // (Cloudflare Pages) inject VITE_CONVEX_URL at build time.
  "https://lovely-sandpiper-137.eu-west-1.convex.cloud";

export const convex = new ConvexReactClient(CONVEX_URL);

// Convex Auth's default storage adapter (localStorage) works fine
// on web — no shim needed. ConvexAuthProvider uses it automatically
// when no `storage` prop is passed.
